export { jsx, jsx as jsxs } from './src/h.ts'
